import { useMemo, useRef } from 'react';

import useStateHandler from '@/hooks/useStateHandler';

import './styles/RatingBarDisplayer.css';

function toSafePercentage(value) {
  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) return 0;
  return Math.min(100, Math.max(0, Math.floor(parsedValue)));
}

export default function RatingBarWithoutMyRating({ username, userRating, includeGuide=false }) {
  const { state } = useStateHandler();
  const userRatingPercentage = useMemo(() => toSafePercentage(userRating), [userRating]);
  const artworkRatingDisplayerContainer = useRef();

  return (
    <>
      <div className="artwork-rating-displayer__range-container" style={{  height: ` 5px ` }} ref={artworkRatingDisplayerContainer}>
        <div style={{ width: `${userRatingPercentage}%` }} className="artwork-rating-displayer__bar user-rating my-rating"/>

        <div  className="artwork-rating-displayer__indicator my-rating">

        </div>
            
        {state.user_session?.user_username !== username && (
          <div className="artwork-rating-displayer__indicator" style={{ left: `${userRatingPercentage}%` }}>
                        
            <div className="artwork-rating-displayer__indicator-bar my-rating"/>
          </div>
        )}

        {includeGuide && <div className="artwork-rating-displayer__guide-container">
          <div style={{ left: "12.5%" }} className="artwork-rating-displayer__guide-indicator"/>
          <div style={{ left: "25%" }} className="artwork-rating-displayer__guide-indicator"/>
          <div style={{ left: "37.5%" }} className="artwork-rating-displayer__guide-indicator"/>
          <div style={{ left: "50%" }} className="artwork-rating-displayer__guide-indicator main"/>
          <div style={{ left: "62.5%" }} className="artwork-rating-displayer__guide-indicator"/>
          <div style={{ left: "75%" }} className="artwork-rating-displayer__guide-indicator"/>
          <div style={{ left: "87.5%" }} className="artwork-rating-displayer__guide-indicator"/>
        </div>}
      </div>
    </>
  );
}
